import { enterStore, getInitData } from "./api/store"
import { local_linkageId, local_systemData, login_token } from "./constant"
import Store from '@scripts/store/store'
import { DataDicGroup, StoreType } from './type'

/**
 * 加载基础数据
 */
export async function getBasicData() {
  if ($app.store) return true                             // 如果全局变量已经加载，则无需后续操作
  if (!localStorage.getItem(login_token)) return false    // token不存在时，无需后续操作
  // 首先加载缓存的数据，没有找到则从服务器获取
  let basicData = JSON.parse(localStorage.getItem(local_systemData) ?? '{}')
  if (!basicData.store) {
    const { data } = await getInitData()
    basicData = data
    // 远端拿到的数据字典，需要处理一下
    const dic = data.dic.map((a: any) => ({ id: a.id, group: a.group, createdTime: a.createdTime, storeId: a.storeId, name: a.name, sort: a.sort, isDelete: false, info: a.info })) as DataDic[]
    basicData.dic = {
      allDic: dic,
      goodAttribute: dic.filter(a => a.group === DataDicGroup.GoodAttribute),
      goodCategory: dic.filter(a => a.group === DataDicGroup.GoodCategory),
      goodTag: dic.first(a => a.group === DataDicGroup.GoodTags) ?? { group: DataDicGroup.GoodTags, name: '商品标签', sort: 1, info: '[]' },
      deskCategory: dic.filter(a => a.group === DataDicGroup.DeskCategory),
      storePayment: dic.first(a => a.group === DataDicGroup.StorePayment) ?? { group: DataDicGroup.StorePayment, name: '支付方式', sort: 2, info: '[]' },
      mealCost: dic.first(a => a.group === DataDicGroup.MealCost) ?? { group: DataDicGroup.MealCost, name: '餐位费', sort: 3, info: 1 },
      storeTime: dic.first(a => a.group === DataDicGroup.StoreTime) ?? { group: DataDicGroup.StoreTime, name: '午市和晚市时间', sort: 4, info: JSON.stringify({ noon: ['11:00:00', '14:00:00'], afternoon: ['16:30:00', '21:00:00'] }) },
      stall: dic.filter(a => a.group === DataDicGroup.Stall),
      activities: dic.filter(a => a.group === DataDicGroup.StoreActivity),
      mallCategory: dic.first(a => a.group === DataDicGroup.MallGoodCategory),
    }
  }
  // 保存到全局变量和本地缓存
  Object.assign($app, basicData)
  saveAppData()

  return true
}

/**
 * 退出登录
 */
export function logout() {
  if ($router.currentRoute.value.fullPath === '/login') return
  $util.modal.destroyAll()
  clear()
  $router.replace('/login')
  setTimeout(() => {
    $app.store = undefined
    $app.dic = undefined
  }, 100)
}

/**
 * 保存缓存数据
 */
export function saveAppData() {
  localStorage.setItem(local_systemData, JSON.stringify($app))
}

/**
 * 清除缓存
 */
export function clear() {
  Store.useTab().removeAll()
  localStorage.removeItem(local_systemData)
  localStorage.removeItem(login_token)
}

/**
 * 进入商户
 * @param id 商户ID
 */
export async function goStore(id: string) {
  // 保存或移除连锁店id
  if ($app.store?.storeType === StoreType.Linkage) {
    sessionStorage.setItem(local_linkageId, $app.store?.id)
  } else sessionStorage.removeItem(local_linkageId)
  // 进入所选择的门店
  await enterStore(id)
  // 移除当前门店的信息
  localStorage.removeItem(local_systemData)
  // 重定向
  location.href = location.protocol + '//' + location.host
}

/**
 * 获取连锁店id
 * @returns 
 */
export function getLinkageId() {
  return sessionStorage.getItem(local_linkageId)
}
